import React from "react";
import { Typography, Layout, Space, Card, Divider, Anchor } from "antd";
import {
  BookOutlined,
  ExclamationCircleOutlined,
  FileProtectOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { MdOutlineEmail } from "react-icons/md";
import { FaAddressCard, FaPhoneVolume } from "react-icons/fa";
import { motion } from "framer-motion";
import { FaShield } from "react-icons/fa6";
import NoticeAILogo from "../../assets/images/LoadingLogo.png";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;
const { Link } = Anchor;

const TermsAndConditions = ({ placement = "default" }) => {
  return (
    <Layout style={{ padding: "24px", background: "#f0f5ff" }}>
      <Content>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Card
            bordered={false}
            style={{
              maxWidth: 1000,
              margin: "0 auto",
              border: "2px solid #f5f5f5",
            }}
          >
            <Typography>
              <Title
                level={placement == "default" ? 2 : 4}
                style={{
                  textAlign: "center",
                  color: "#2746b2",
                  fontWeight: 700,
                  textDecoration: "underline",
                }}
              >
                {placement !== "default"
                  ? "TERMS OF USE AND DISCLAIMER"
                  : "Terms and Conditions"}
                <br />
                {placement !== "default" ? "Tax Notice Response Generator" : ""}

                {placement == "default" && (
                  <div className="flex items-center justify-center w-full mt-4">
                    <motion.img
                      src={NoticeAILogo}
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                      style={{
                        marginBottom: 5,
                        zIndex: 2,
                        width: "130px",
                      }}
                    />
                  </div>
                )}
              </Title>
              {placement !== "default" && (
                <Paragraph style={{ textAlign: "center", fontWeight: "bold" }}>
                  PLEASE READ THIS AGREEMENT CAREFULLY BEFORE USING THE SERVICE
                </Paragraph>
              )}
              {placement == "default" && (
                <Paragraph>
                  Please read these Terms and Conditions ("Terms", "Terms and
                  Conditions") carefully before using the NoticeAI (the
                  "Service") operated by NABS AI Solutions Pvt. Ltd. ("us",
                  "we", or "our").
                </Paragraph>
              )}
              {placement == "default" && (
                <Paragraph>
                  Your access to and use of the Service is conditioned on your
                  acceptance of and compliance with these Terms. These Terms
                  apply to all visitors, users, and others who access or use the
                  Service.
                </Paragraph>
              )}

              {placement == "default" && (
                <Paragraph>
                  By accessing or using the Service, you agree to be bound by
                  these Terms. If you disagree with any part of the terms, you
                  may not access the Service.
                </Paragraph>
              )}
              {placement == "default" && <Divider />}
              {placement !== "default" ? (
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ display: "flex" }}
                >
                  <div id="data-privacy">
                    <Title
                      level={5}
                      style={{
                        color: "#2746b2",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <FaShield /> 1. DATA PRIVACY AND CONFIDENTIALITY
                    </Title>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text strong>1.1 Data Processing: </Text>
                          While our Service employs advanced masking algorithms
                          to protect sensitive information before transmission
                          to external AI systems, you acknowledge that no
                          masking system is 100% foolproof.
                        </li>
                        <li>
                          <Text strong>1.2 User Responsibility: </Text>
                          You are solely responsible for the data you upload to
                          the Service. You affirm that you have the legal right
                          to upload and process all documents submitted to the
                          Service.
                        </li>
                        <li>
                          <Text strong>1.3 Sensitive Information: </Text>
                          Although our system attempts to mask sensitive data
                          (including but not limited to PAN numbers, Aadhaar
                          numbers, bank account details, phone numbers, and
                          personal addresses), you acknowledge that certain
                          information may not be properly masked due to
                          formatting anomalies, pattern variations, or other
                          technical limitations.
                        </li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="limitation-liability">
                    <Title
                      level={5}
                      style={{
                        color: "#2746b2",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <ExclamationCircleOutlined /> 2. LIMITATION OF LIABILITY
                    </Title>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text strong>2.1 No Warranty: </Text>
                          The Service is provided on an "AS IS" and "AS
                          AVAILABLE" basis without warranties of any kind,
                          either express or implied.
                        </li>
                        <li>
                          <Text strong>2.2 Data Leakage: </Text>
                          We shall not be liable for any exposure, leakage, or
                          misuse of your information that occurs despite our
                          masking efforts, including information transmitted to
                          third-party AI services.
                        </li>
                        <li>
                          <Text strong>2.3 Consequential Damages: </Text>
                          Under no circumstances shall we be liable for any
                          direct, indirect, incidental, special, consequential,
                          or exemplary damages arising from your use of the
                          Service or any data privacy incidents.
                        </li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="indemnification">
                    <Title
                      level={5}
                      style={{
                        color: "#2746b2",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <FileProtectOutlined /> 3. INDEMNIFICATION
                    </Title>
                    <Paragraph>
                      3.1 You agree to indemnify, defend, and hold harmless our
                      company, its officers, directors, employees, agents, and
                      affiliates from and against any and all claims,
                      liabilities, damages, losses, costs, expenses, or fees
                      (including reasonable attorneys' fees) arising from:
                      <ul>
                        <li>a) Your use of the Service;</li>
                        <li>b) Any data you upload to the Service;</li>
                        <li>c) Your violation of these terms; or</li>
                        <li>
                          d) Your violation of any rights of another person or
                          entity.
                        </li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="user-representations">
                    <Title
                      level={5}
                      style={{
                        color: "#2746b2",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <BookOutlined /> 4. USER REPRESENTATIONS
                    </Title>
                    <Paragraph>
                      By using this Service, you represent and warrant that:
                      <ul>
                        <li>
                          <Text strong>4.1 </Text>
                          You have reviewed the documents you are uploading and
                          have taken reasonable steps to verify they do not
                          contain highly sensitive information that should not
                          be processed.
                        </li>
                        <li>
                          <Text strong>4.2 </Text>
                          You understand that the AI-generated responses are for
                          reference purposes only and should be reviewed by
                          qualified professionals before submission to tax
                          authorities.
                        </li>
                        <li>
                          <Text strong>4.3 </Text>
                          You accept full responsibility for ensuring the
                          accuracy and appropriateness of the final responses
                          before submission to any governmental authority.
                        </li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="governing-law">
                    <Title
                      level={5}
                      style={{
                        color: "#2746b2",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <GlobalOutlined /> 5. GOVERNING LAW
                    </Title>
                    <Paragraph>
                      These Terms shall be governed by and construed in
                      accordance with the laws of India, without regard to its
                      conflict of law provisions.
                    </Paragraph>
                  </div>
                </Space>
              ) : (
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ display: "flex" }}
                >
                  <div id="definitions">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 1. DEFINITIONS
                    </Title>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text strong>"Service" </Text> refers to the NoticeAI,
                          including all its features and functionalities.
                        </li>
                        <li>
                          <Text strong>"User"</Text> or{" "}
                          <Text strong>"you"</Text> refers to the individual or
                          entity that registers to use the Service.
                        </li>
                        <li>
                          <Text strong>"User Data"</Text> refers to any data,
                          information, or materials that Users provide to or
                          through the Service, including but not limited to tax
                          notices, client information, and response drafts.
                        </li>
                        <li>
                          <Text strong>"Client"</Text> refers to any individual
                          or entity for whom the User provides professional
                          services and whose information may be processed
                          through the Service.
                        </li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="account-registration">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 2. ACCOUNT REGISTRATION AND SECURITY
                    </Title>
                    <Paragraph>
                      2.1 To access certain features of the Service, you must
                      register for an account. You agree to provide accurate,
                      current, and complete information during the registration
                      process and to update such information to keep it
                      accurate, current, and complete.
                    </Paragraph>
                    <Paragraph>
                      2.2 You are responsible for safeguarding the password that
                      you use to access the Service and for any activities or
                      actions under your password.
                    </Paragraph>
                    <Paragraph>
                      2.3 You agree not to disclose your password to any third
                      party. You must notify us immediately upon becoming aware
                      of any breach of security or unauthorized use of your
                      account.
                    </Paragraph>
                  </div>

                  <div id="data-storage">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 3. DATA STORAGE AND PROCESSING
                    </Title>
                    <Paragraph>
                      3.1 <Text strong>Data Storage Authorization:</Text> By
                      using our Service, you explicitly authorize us to store
                      and process User Data, including tax notices and related
                      documents, on third-party servers and cloud storage
                      solutions including but not limited to Amazon Web
                      Services, Digital Ocean, and other cloud service
                      providers.
                    </Paragraph>
                    <Paragraph>
                      3.2 <Text strong>Data Ownership:</Text> You retain all
                      ownership rights to your User Data. We do not claim
                      ownership of any User Data submitted to or through the
                      Service.
                    </Paragraph>
                    <Paragraph>
                      3.3 <Text strong>Data Processing:</Text> You authorize us
                      to process your User Data for the purposes of:
                      <ul>
                        <li>Retrieving tax notices from government portals</li>
                        <li>Analyzing notice content</li>
                        <li>Generating response drafts</li>
                        <li>Managing deadlines and notifications</li>
                        <li>
                          Maintaining records for your practice management
                        </li>
                      </ul>
                    </Paragraph>
                    <Paragraph>
                      3.4 <Text strong>Data Security:</Text> We implement
                      reasonable security measures to protect User Data against
                      unauthorized access or disclosure. However, no method of
                      electronic storage or transmission is 100% secure, and we
                      cannot guarantee absolute security.
                    </Paragraph>
                    <Paragraph>
                      3.5 <Text strong>Data Retention:</Text> We will retain
                      your User Data for as long as your account remains active
                      or as needed to provide the Service. Upon account
                      termination, we will retain User Data for a reasonable
                      period as required by law or for legitimate business
                      purposes.
                    </Paragraph>
                  </div>

                  <div id="user-responsibilities">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 4. USER RESPONSIBILITIES AND
                      REPRESENTATIONS
                    </Title>
                    <Paragraph>
                      4.1 You represent and warrant that:
                      <ul>
                        <li>
                          You have obtained all necessary consents from your
                          Clients to store and process their information through
                          our Service.
                        </li>
                        <li>
                          You have the legal right to provide us with User Data.
                        </li>
                        <li>
                          Your use of the Service complies with all applicable
                          laws and regulations, including data protection and
                          privacy laws.
                        </li>
                      </ul>
                    </Paragraph>
                    <Paragraph>
                      4.2 You shall not use the Service to:
                      <ul>
                        <li>Violate any laws.</li>
                        <li>Infringe the rights of others.</li>
                        <li>Send spam or unsolicited communications.</li>
                        <li>Transmit malware or other harmful code.</li>
                        <li>
                          Attempt to gain unauthorized access to any part of the
                          Service.
                        </li>
                      </ul>
                    </Paragraph>
                    <Paragraph>
                      4.3 <Text strong>Professional Responsibility:</Text> You
                      acknowledge that the Service is designed to assist tax
                      professionals but not replace professional judgment. You
                      remain solely responsible for:
                      <ul>
                        <li>
                          The accuracy and completeness of all responses
                          submitted to tax authorities.
                        </li>
                        <li>
                          Reviewing all AI-generated content before submission.
                        </li>
                        <li>
                          Meeting all statutory deadlines and requirements.
                        </li>
                        <li>Maintaining appropriate professional standards.</li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="privacy-policy">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 5. PRIVACY POLICY
                    </Title>
                    <Paragraph>
                      5.1 Our Privacy Policy, available at{" "}
                      <a
                        href="https://infinabs.ai/privacy-policy"
                        style={{
                          color: "#004080",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                      , describes how we collect, use, and share your personal
                      information. By using our Service, you acknowledge that
                      you have read and understood our Privacy Policy.
                    </Paragraph>
                    <Paragraph>
                      5.2 <Text strong>Confidentiality:</Text> We understand the
                      sensitive nature of tax and financial information. We are
                      committed to maintaining the confidentiality of your User
                      Data and will not disclose it to unauthorized third
                      parties except as permitted by these Terms or our Privacy
                      Policy.
                    </Paragraph>
                  </div>

                  <div id="intellectual-property">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 6. INTELLECTUAL PROPERTY
                    </Title>
                    <Paragraph>
                      6.1 <Text strong>Our Intellectual Property:</Text> The
                      Service, including its software, features, graphics, user
                      interface, and content (excluding User Data), is owned by
                      us and is protected by copyright, trademark, and other
                      intellectual property laws.
                    </Paragraph>
                    <Paragraph>
                      6.2 <Text strong>Limited License:</Text> We grant you a
                      limited, non-exclusive, non-transferable, revocable
                      license to use the Service solely for your internal
                      business purposes and in accordance with these Terms.
                    </Paragraph>
                    <Paragraph>
                      6.3 <Text strong>Restrictions:</Text> You shall not:
                      <ul>
                        <li>
                          Copy, modify, distribute, sell, or lease any part of
                          the Service
                        </li>
                        <li>
                          Reverse engineer or attempt to extract the source code
                          of the Service
                        </li>
                        <li>
                          Remove any copyright, trademark, or other proprietary
                          notices
                        </li>
                        <li>Create derivative works based on the Service</li>
                      </ul>
                    </Paragraph>
                  </div>

                  <div id="subscription-and-payment">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 7. SUBSCRIPTION AND PAYMENT
                    </Title>
                    <Paragraph>
                      7.1 <Text strong>Subscription:</Text> Access to the
                      Service requires payment of subscription fees as outlined
                      on our pricing page.
                    </Paragraph>
                    <Paragraph>
                      7.2 <Text strong>Payment:</Text> All payments must be made
                      in advance. We accept payment through [Payment Methods].
                    </Paragraph>
                    <Paragraph>
                      7.3 <Text strong>Taxes:</Text> All fees are exclusive of
                      taxes. You are responsible for paying all applicable taxes
                      related to your use of the Service.
                    </Paragraph>
                  </div>

                  <div id="termination">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 8. TERMINATION
                    </Title>
                    <Paragraph>
                      8.1 <Text strong>Termination by You:</Text> You may
                      terminate your account at any time by following the
                      instructions on the Service or by contacting our support
                      team.
                    </Paragraph>
                    <Paragraph>
                      8.2 <Text strong>Termination by Us:</Text> We may
                      terminate or suspend your account immediately, without
                      prior notice or liability, for any reason, including if
                      you breach these Terms.
                    </Paragraph>
                    <Paragraph>
                      8.3 <Text strong>Effect of Termination:</Text> Upon
                      termination, your right to use the Service will
                      immediately cease. We will provide you with a reasonable
                      opportunity to download your User Data before account
                      deletion.
                    </Paragraph>
                  </div>

                  <div id="disclaimer-of-warranties">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 9. DISCLAIMER OF WARRANTIES
                    </Title>
                    <Paragraph>
                      9.1 THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE"
                      WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
                    </Paragraph>
                    <Paragraph>
                      9.2 We do not warrant that:
                      <ul>
                        <li>
                          The Service will function uninterrupted or be
                          available at any particular time or location.
                        </li>
                        <li>
                          All errors or defects will be corrected immediately.
                        </li>
                        <li>
                          The Service is completely immune to all security
                          threats.
                        </li>
                        <li>
                          Results obtained from using the Service will be
                          accurate or reliable in all circumstances.
                        </li>
                      </ul>
                    </Paragraph>
                    <Paragraph>
                      9.3 <Text strong>AI-Generated Content:</Text> We make no
                      warranties regarding the accuracy or suitability of
                      AI-generated content for your specific needs.
                    </Paragraph>
                  </div>

                  <div id="limitation-of-liability">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 10. LIMITATION OF LIABILITY
                    </Title>
                    <Paragraph>
                      10.1 TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT
                      BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                      CONSEQUENTIAL, OR PUNITIVE DAMAGES.
                    </Paragraph>
                    <Paragraph>
                      10.2 Our liability is limited to the amount paid by you
                      for the Service during the 12 months preceding the claim.
                    </Paragraph>
                  </div>

                  <div id="indemnification">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 11. INDEMNIFICATION
                    </Title>
                    <Paragraph>
                      11.1 You agree to defend, indemnify, and hold harmless us,
                      our affiliates, licensors, and service providers, and our
                      and their respective officers, directors, employees,
                      contractors, agents, licensors, suppliers, successors, and
                      assigns from and against any claims, liabilities, damages,
                      judgments, awards, losses, costs, expenses, or fees
                      (including reasonable attorneys' fees) arising out of or
                      relating to:
                    </Paragraph>
                    <ul>
                      <li>Your violation of these Terms</li>
                      <li>Your User Data</li>
                      <li>Your use of the Service</li>
                    </ul>
                  </div>

                  <div id="changes-to-terms">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 12. CHANGES TO TERMS
                    </Title>
                    <Paragraph>
                      12.1 We reserve the right, at our sole discretion, to
                      modify or replace these Terms at any time. We will provide
                      notice of any changes by posting the new Terms on this
                      page and updating the "Last Updated" date.
                    </Paragraph>
                    <Paragraph>
                      12.2 Your continued use of the Service after any such
                      changes constitutes your acceptance of the new Terms.
                    </Paragraph>
                  </div>

                  <div id="governing-law">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 13. GOVERNING LAW
                    </Title>
                    <Paragraph>
                      13.1 These Terms shall be governed by and construed in
                      accordance with the laws of India, without regard to its
                      conflict of law provisions.
                    </Paragraph>
                    <Paragraph>
                      13.2 Any disputes arising under these Terms shall be
                      resolved exclusively in the courts located in Hisar,
                      Haryana, India.
                    </Paragraph>
                  </div>

                  <div id="severability">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 14. SEVERABILITY
                    </Title>
                    <Paragraph>
                      14.1 If any provision of these Terms is held to be
                      unenforceable or invalid, such provision will be changed
                      and interpreted to accomplish the objectives of such
                      provision to the greatest extent possible under applicable
                      law, and the remaining provisions will continue in full
                      force and effect.
                    </Paragraph>
                  </div>

                  <div id="entire-agreement">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 15. ENTIRE AGREEMENT
                    </Title>
                    <Paragraph>
                      15.1 These Terms, together with our Privacy Policy and any
                      other legal notices published by us on the Service,
                      constitute the entire agreement between you and us
                      concerning the Service.
                    </Paragraph>
                  </div>

                  <div id="contact-us">
                    <Title level={4} style={{ color: "#2746b2" }}>
                      <BookOutlined /> 16. CONTACT US
                    </Title>
                    <Paragraph>
                      If you have any questions about these Terms, please
                      contact us at:
                    </Paragraph>
                    <Paragraph>
                      <div className="flex gap-1 items-center font-bold text-blue-900">
                        <MdOutlineEmail /> : info@nabsai.com
                      </div>
                      <div className="flex gap-1 items-center font-bold text-blue-900">
                        <FaAddressCard />: A-7 First Floor Jawahar Park, Devli
                        Road, New Delhi 110062
                      </div>

                      <div className="flex gap-1 items-center font-bold text-blue-900">
                        <FaPhoneVolume />: +91 7015591070
                      </div>
                      <br />
                    </Paragraph>
                  </div>
                </Space>
              )}
              {placement !== "default" && <Divider />}
              {placement !== "default" && (
                <Paragraph>
                  Your access to and use of the Service is conditioned on your
                  acceptance of and compliance with these Terms. These Terms
                  apply to all visitors, users, and others who access or use the
                  Service.
                </Paragraph>
              )}

              {placement !== "default" && (
                <Paragraph>
                  By accessing or using the Service, you agree to be bound by
                  these Terms. If you disagree with any part of the terms, you
                  may not access the Service.
                </Paragraph>
              )}
            </Typography>
          </Card>
        </motion.div>
      </Content>
    </Layout>
  );
};

export default TermsAndConditions;
